import PurchasedCoursesFilterWidget from 'cle/purchased_courses_filter_widget'
import SortBySelectWidget from 'components/algolia/sort_by_select_widget'
import Quimbee from 'quimbee'

export function purchasedCoursesFilter(purchasedCoursesIds, itemsContainerId) {
  return new PurchasedCoursesFilterWidget({
    filterContainerId: "purchased_items",
    filterLabel: "Only display purchased courses",
    purchasedItemsIds: purchasedCoursesIds,
    includePurchasedItemsCount: true,
    itemsContainerId: itemsContainerId
  })
}

export function sortingWidget() {
  return new SortBySelectWidget({ selectType: "single" }).widget({
    container: 'sort-by-container',
    items: [
      { value: Quimbee.data.algolia.CLESearch.sortingIndexNames.publishedAt, label: 'Newest' },
      { value: Quimbee.data.algolia.CLESearch.sortingIndexNames.popularity, label: 'Most Popular' },
      { value: Quimbee.data.algolia.CLESearch.sortingIndexNames.rating, label: 'Top Rated'}
    ],
    transformItems: (items) => {
      return items.map(item => ({
        ...item
      }))
    }
  })
}
